import {btbIndustry, ratioMaxLengthMap, designSizeOptions} from './constants.js';

export const getMaxLength = e => {
    const {ext: {industryList}, formData: {industry, sizeControl}, config: {name}} = e;
    const isBtB = industryList.length
        && btbIndustry.includes(industryList.find(item => item.value === industry.value)?.label);
    const ratio = sizeControl.value.ratio;

    const ratioMaxLength = isBtB
        ? ratioMaxLengthMap.btb[name]
        : (ratioMaxLengthMap[ratio] ? ratioMaxLengthMap[ratio][name] : ratioMaxLengthMap.base[name]);

    return ratioMaxLength;
};

export const getTplOptions = e => {
    const btbSize = ['3:2', '1:1'];
    const otherSize = ['16:9', '1:1'];
    const {ext: {industryList}, formData: {industry}} = e;
    const isBtB = industryList.length
        && btbIndustry.includes(industryList.find(item => item.value === industry.value)?.label);
    const sizeOptions = designSizeOptions.filter(option =>
        (isBtB ? btbSize : otherSize).includes(option.value)
    );

    return sizeOptions;
};
